const devConfig = {
    env: "dev",
    baseUrl: "http://localhost:8000/v1/admin",
}

const stagingConfig = {
    env: "staging",
    baseUrl: "https://uat-supernova.zave.app/v1/admin",
}

const prodConfig = {
    env: "prod",
    baseUrl: "https://api.supernova.zave.app/v1/admin",
}

export default stagingConfig